import { useTranslation } from 'react-i18next';

const certificates = [
  { name: 'CE Belgesi', file: 'CE.pdf' },
  { name: 'ISO 9001', file: 'ISO9001.pdf' },
  { name: 'ISO 9001-77', file: 'ISO9001-77.pdf' },
  { name: 'ISO 10002', file: 'ISO10002.pdf' },
  { name: 'ISO 14001', file: 'ISO14001.pdf' },
  { name: 'ISO 45001', file: 'ISO45001.pdf' },
];

const BASE_URL = 'https://okayisu.com/common/img/belgeler/';

export default function About() {
  const { t } = useTranslation();

  const statsList = [
    { value: '22+', label: t('stats.yearsExperience'), icon: 'ri-calendar-check-line' },
    { value: '1000+', label: t('stats.completedProjects'), icon: 'ri-building-line' },
    { value: '20', label: t('stats.countriesService'), icon: 'ri-global-line' },
    { value: '%100', label: t('stats.customerSatisfaction'), icon: 'ri-star-line' },
  ];

  const strengthsList = [
    t('about.strength1'),
    t('about.strength2'),
    t('about.strength3'),
    t('about.strength4'),
    t('about.strength5'),
  ];

  return (
    <section id="about" className="bg-gray-50 py-28 px-6 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 mb-20">
          {statsList.map((stat, idx) => (
            <div key={idx} className="bg-white border border-gray-100 rounded-2xl p-6 text-center hover:border-amber-200 transition-all duration-300" style={{ boxShadow: '0 1px 4px rgba(0,0,0,0.05)' }}>
              <div className="w-11 h-11 flex items-center justify-center mx-auto mb-3 bg-amber-50 rounded-xl">
                <i className={`${stat.icon} text-amber-500 text-xl`} />
              </div>
              <div className="text-amber-500 text-3xl font-bold mb-1" style={{ fontFamily: "'Montserrat', sans-serif" }}>{stat.value}</div>
              <div className="text-gray-500 text-xs tracking-wide font-medium" style={{ fontFamily: "'Inter', sans-serif" }}>{stat.label}</div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div className="relative">
            <div className="w-full h-[460px] rounded-3xl overflow-hidden">
              <img src="https://readdy.ai/api/search-image?query=professional%20LED%20lighting%20design%20team%20engineers%20working%20in%20modern%20bright%20office%20workspace%20technical%20drawing%20plans%20architectural%20lighting%20project%20management%20bright%20interior%20natural%20light%20professional%20corporate%20photography&width=700&height=520&seq=about1light&orientation=portrait" alt="OKAYISU Team" className="w-full h-full object-cover object-top" />
            </div>
            <div className="absolute -bottom-5 -right-3 bg-amber-500 rounded-2xl p-5 text-white hidden md:block" style={{ boxShadow: '0 8px 24px rgba(245,158,11,0.35)' }}>
              <div className="text-3xl font-bold" style={{ fontFamily: "'Montserrat', sans-serif" }}>22+</div>
              <div className="text-xs font-medium text-white/80 mt-0.5" style={{ fontFamily: "'Inter', sans-serif" }}>{t('stats.yearsExperience')}</div>
            </div>
            <div className="absolute -top-4 -left-4 w-20 h-20 border-2 border-amber-200 rounded-2xl hidden md:block" />
          </div>

          <div>
            <div className="inline-flex items-center gap-2 bg-amber-50 border border-amber-200 rounded-full px-4 py-1.5 mb-6">
              <span className="w-1 h-1 bg-amber-500 rounded-full" />
              <span className="text-amber-600 text-xs tracking-[0.2em] uppercase font-semibold" style={{ fontFamily: "'Montserrat', sans-serif" }}>{t('about.badge')}</span>
            </div>
            <h2 className="text-gray-900 text-3xl md:text-4xl font-bold leading-tight mb-6" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              {t('about.heading1')}<br />
              <span className="text-amber-500">{t('about.heading2')}</span>
            </h2>
            <p className="text-gray-600 text-sm leading-relaxed mb-5" style={{ fontFamily: "'Inter', sans-serif" }}>{t('about.paragraph1')}</p>
            <p className="text-gray-500 text-sm leading-relaxed mb-8" style={{ fontFamily: "'Inter', sans-serif" }}>{t('about.paragraph2')}</p>
            <ul className="space-y-3 mb-8">
              {strengthsList.map((item, idx) => (
                <li key={idx} className="flex items-center gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 bg-amber-100 rounded-full">
                    <i className="ri-check-line text-amber-600 text-xs" />
                  </div>
                  <span className="text-gray-600 text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>{item}</span>
                </li>
              ))}
            </ul>
            <button onClick={() => { const el = document.querySelector('#contact'); if (el) el.scrollIntoView({ behavior: 'smooth' }); }} className="inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-600 text-white font-semibold px-7 py-3.5 rounded-full text-sm tracking-wide transition-all duration-300 cursor-pointer whitespace-nowrap" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              {t('about.workWithUs')}
              <i className="ri-arrow-right-line" />
            </button>
          </div>
        </div>

        <div className="mt-20">
          <div className="text-center mb-10">
            <h3 className="text-gray-900 text-2xl md:text-3xl font-bold mb-2" style={{ fontFamily: "'Montserrat', sans-serif" }}>{t('about.certificates')}</h3>
            <p className="text-gray-500 text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>{t('about.certificatesDesc')}</p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
            {certificates.map((cert, idx) => (
              <a key={idx} href={`${BASE_URL}${cert.file}`} target="_blank" rel="noopener noreferrer" className="group bg-white border border-gray-100 rounded-xl p-5 flex flex-col items-center gap-3 hover:border-amber-300 hover:bg-amber-50/50 transition-all duration-300 cursor-pointer" style={{ boxShadow: '0 1px 4px rgba(0,0,0,0.05)' }}>
                <div className="w-10 h-10 flex items-center justify-center bg-red-50 rounded-lg group-hover:bg-red-100 transition-colors duration-300">
                  <i className="ri-file-pdf-line text-red-500 text-xl" />
                </div>
                <span className="text-gray-700 text-xs font-semibold text-center leading-tight" style={{ fontFamily: "'Inter', sans-serif" }}>{cert.name}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}